/* jshint esversion: 6 */
import RouteView from "@/views/common/views/RouteView";
// import { device } from "@/utils";

// 将需要动态注册的路由提取到vuex中
export default [
{
    path: "/diagnosefw",
    name: "diagnosefw",
    title: "诊断服务-服务商",
    sort: 3,
    redirect: "/diagnosefw/project",
    component: RouteView,
    meta: { title: "诊断服务-服务商", icon: "ios-keypad" },
    children: [
      {
        path: "/diagnosefw/projectManagement",
        component: () => import("@/views/pc/diagnosefw/projectManagement"),
        name: "diagnosefw-projectManagement",
        sort: 1,
        hideChildrenInMenu: true,
        meta: {
          title: "项目管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [
        ],
      },
      {
        path: "/diagnose/trackFw",
        component: () => import("@/views/pc/diagnosefw/trackFw"),
        name: "trackFw",
        sort: 1,
        hideChildrenInMenu: true,
        meta: {
          title: "进展跟踪",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [
          // {
          //   name: "sys_trackFw_upload",
          //   meta: {
          //     title: "上传附件",
          //     perms: "sys:trackFw:upload",
          //   },
          // },
          // {
          //   name: "sys_trackFw_update",
          //   meta: {
          //     title: "修改日期",
          //     perms: "sys:trackFw:update",
          //   },
          // },
          // {
          //   name: "sys_trackFw_deleted",
          //   meta: {
          //     title: "删除附件",
          //     perms: "sys:trackFw:deleted",
          //   },
          // },
          // {
          //   name: "sys_trackFw_audit",
          //   meta: {
          //     title: "审核服务",
          //     perms: "sys:trackFw:audit",
          //   },
          // },
          // {
          //   name: "sys_trackFw_regression",
          //   meta: {
          //     title: "退回服务",
          //     perms: "sys:trackFw:regression",
          //   },
          // },
        ],
      },
      {
        path: "/diagnosefw/project-management/:action(list)/:id",
        component: () => import("@/views/pc/diagnosefw/projectManagement/list"),
        name: "diagnosefw-ManagementEnterpriseList",
        hidden: true,
        meta: {
          title: "企业列表",
          keepAlive: false,
          },
        },
        {
          path: "/diagnosefw/project-management/edit/:id",
          component: () => import("@/views/pc/diagnosefw/projectManagement/editTwo"),
          name: "diagnosefw-schedule",
          hidden: true,
          meta: {
            title: "上传服务资料",
            keepAlive: false,
          },
          children: [
            {
              name: "pms_projectManagement_back",
              meta: {
                title: "重新提交",
                perms: "pms:projectManagement:back",
              },
            },
          ],
        },
      {
        path: "/diagnosefw/projectfw",
        component: () => import("@/views/pc/diagnosefw/serviceCompany"),
        name: "diagnosefw-project",
        sort: 1,
        hideChildrenInMenu: true,
        meta: {
          title: "团队管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [
          {
            path: "/diagnosefw/service-company/:action(aprv|edit|copy|show)/:id",
            name: "membersfw",
            sort: 1,
            component: () => import("@/views/pc/diagnosefw/serviceCompany"),
            meta: {
              title: "成员",
              keepAlive: false,
            },
          },]
      },
      {
        path: "/diagnosefw/appointment",
        component: () => import("@/views/pc/diagnosefw/appointment"),
        name: "diagnosefw-appointment",
        sort: 2,
        hideChildrenInMenu: true,
        meta: {
          title: "预约管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [
          {
            path: "/diagnosefw/appointment-add",
            name: "appointmentFw-add",
            sort: 1,
            component: () => import("@/views/pc/diagnosefw/appointment/edit"),
            meta: {
              title: "新增预约信息",
              keepAlive: false,
            },
          },
        ],
      },
      {
        path:"/diagnosefw/childrenAccount",
        component: () => import("@/views/pc/diagnosefw/childrenAccount"),
        name:"diagnosefw-childrenAccount",
        sort: 4,
        hideChildrenInMenu :true,
        meta:{
          title :"子账号管理",
          hiddenHeaderTitle: true,
          icon: "md-list-box",
        },
        children: [
        ],
      }
    ]
  },
];
